/** Keys must be in Swedish */

export const en = {
  "Ofullständigt konto": "We miss some information from your account.",
  "Vänligen välj ditt kontotyp för att se och skicka in ansökningar.":
    "Please select your account type to view and submit applications.",
  "Försök igen": "Try again",
  "Gå tillbaka": "Go back",
  Serverfel: "Server error",
  "Något gick fel på vår sida!": "Something went wrong on our end!",
  "Fungerar det inte även om du har försökt igen? Vänligen kontakta oss och beskriv vad du gjorde.":
    "Does it not work even if you have tried again? Please contact us and describe what you did.",
  "Ingen åtkomst": "No access",
  "Förbjuden åtkomst": "Forbidden access",
  "Du kan inte komma åt denna sida.": "You cannot access this page",
  "Verkar det ha blivit ett fel? Vänligen kontakta oss och beskriv vad du gjorde.":
    "Did something go wrong? Please contact us and describe what you did.",
  config: "Settings",
  Rapporter: "Reports",
  Rapport: "Report",
  ADMIN: "Administrator",
  USER: "User",
  Tillbaka: "Previous",
  Nästa: "Next",
  "av val": "of",
  "rad(er)": "row(s)",
  Sida: "Page",
  Sök: "Search",
  "Välj ansökan": "Select application",
  "Ansökan (om ej i listan, vänligen lämna tomt)":
    "Application (if not in list, please leave blank)",
  "Ansökan ej länkad": "No application linked",
  "Inga resultat": "No results",
  "Inga tidigare ansökningar": "No previous applications",
  "Inga tidigare rapporter": "No previous reports",
  "Kopiera länk": "Copy link",
  "Kopiera ansökningsnummer": "Copy application number",
  "Öppna ansökan": "Open application",
  "Ta bort ansökan": "Delete application",
  "Ansökan borttagen": "Application deleted",
  "Är du säker på att du vill ta bort denna ansökan? Detta går inte att ångra.":
    "Are you sure you want to delete this application? This cannot be undone.",
  "Öppna rapport": "Open report",
  Från: "From",
  "Öppna meddelande": "Open message",
  Arkiverade: "Archived",
  Spamfilter: "Spam filters",
  Avarkivera: "Unarchive",
  Uppdatera: "Refresh",
  "Request metadata": "Request metadata",
  "Välj ett värde från detta meddelande för att blockera framtida försök.":
    "Pick a value from this message to block future attempts.",
  "Blockera e-post": "Block email",
  "Blockera e-postdomän": "Block email domain",
  "Blockera namn": "Block name",
  "Blockera IP": "Block IP",
  "Blockera User-Agent (innehåller)": "Block User-Agent (contains)",
  "Blockera Referrer (innehåller)": "Block Referrer (contains)",
  "Lägg till": "Add",
  Fält: "Field",
  Matchning: "Match",
  Värde: "Value",
  Notering: "Note",
  Förslag: "Suggestions",
  Kolumner: "Columns",
  Ansökningsperiod: "Application period",
  "Alla perioder": "All periods",
  Beslutslista: "Decision list",
  "Skapa beslutslista": "Create decision list",
  "Öppna beslutslista": "Open decision list",
  "Uppdatera beslutslista": "Refresh decision list",
  "Beslutslistan skapades i Google Kalkylark.":
    "The decision list was created in Google Sheets.",
  "Beslutslistan uppdaterades.": "The decision list was updated.",
  "Kunde inte skapa beslutslistan.": "Could not create the decision list.",
  accountType: "Account type",
  Kontotyp: "Account type",
  "Förvald tab": "Default tab",
  "Kan Använda AI": "Can use AI",
  Aktiv: "Enabled",
  Avstängd: "Disabled",
  "Konto raderat": "Account deleted",
  "Är du säker på att du vill radera detta konto? Detta går inte att ångra.":
    "Are you sure you want to delete this account? This cannot be undone.",
  "Radera konto": "Delete account",
  role: "Role",
  emailVerified: "Email verified",
  topic: "Topic",
  read: "Read",
  deletedAt: "Deleted at",
  adminId: "Admin ID",
  inquiryId: "Message ID",
  adminEmail: "Admin email",
  inquirerName: "Inquirer name",
  inquirerEmail: "Inquirer email",
  inquirerSenderType: "Inquirer sender type",
  inquirerTopic: "Inquirer topic",
  inquirerMessage: "Inquirer message",
  adminImage: "Admin profile image",
  senderType: "Sender type",
  image: "Image",
  enabled: "Enabled",
  Aktiverad: "Enabled",
  Fråga: "Question",
  "Svar från": "Answer from",
  Mottagare: "Recipient",
  Avsändare: "Sender",
  "Öppna användare": "Open user",
  valda: "selected",
  app: `app`,
  user: `user`,
  email_address: "email address",
  account_type: "account type",
  musician: "musician",
  researcher: "researcher",
  organization: "organization",
  other: "other",
  "Logga ut": "Sign out",
  yes: "yes",
  no: "no",
  open: "open",
  "404": "page not found",
  "404_text":
    "Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your spelling.",
  "Våra anslag": "Scholarships and grants",
  go_to_home: "Go to home",
  sign_in_title: "Sign in to KC-Fonden",
  list: `list`,
  create_user: "Create user",
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `New Application`,
  history: `Previous Applications`,
  previous_reports: `Previous Reports`,
  new_report: `New Report`,
  report: `report`,
  reportId: `Report`,
  "Ej länkad": "Not linked",
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  message: "message",
  messages: "messages",
  inbox: "inbox",
  sent: "sent",
  mode: "Light/Dark",
  presets: "Presets",
  settings: "Settings",
  fullscreen: "Full-screen",
  fullscreen_off: "Exit full-screen",
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  admin_login: "Login as admin",
  read_more: "read more",
  spring: "spring",
  summer: "summer",
  fall: "fall",
  winter: "winter",
  "Sidan hittades inte": "page not found",
  "Stiftelsen Kempe-Carlgrenska Fonden": "Stiftelsen Kempe-Carlgrenska Fonden",
  "En allmännyttig stiftelse för projekt som rör barn & unga.":
    "A nonprofit foundation for projects related to children and young people.",
  "Bidrag är i första hand avsedda för att täcka direkta kostnader kopplade till projektets genomförande. Vi tillåter att en begränsad del av bidraget används för overheadkostnader (5-10%), men kräver då en detaljerad och tydlig redovisning av det totala bidragsbeloppet. Kostnader som inte är direkt kopplade till projektet, och som inte kan specificeras, kommer inte att godkännas.":
    "Grants are primarily intended to cover direct costs associated with the implementation of the project. A limited portion of the grant (5-10%) may be used for overhead costs, but this requires a detailed and transparent accounting of the total grant amount. Costs that are not directly linked to the project and cannot be specified will not be approved.",
  Ansökningar: "Applications",
  "Ansökningar och rapporter": "Applications and Reports",
  "Antal per sida": "Number per page",
  "Om oss": "About us",
  Kontakt: "Contact us",
  Skicka: "Send",
  Exportera: "Export",
  "Vad vi gör": "What We Do",
  Integritetspolicy: "Privacy Policy",
  Integritets: "Privacy",
  Policy: "Policy",
  "Läs om vilka data vi samlar in": "Read what data we collect",
  "och hur vi använder dem.": "and how we use it.",
  "Giltighetsdatum: 2024-01-01": "Effective Date: 2024-01-01",
  '1. Introduktion\n\nStiftelsen Kempe-Carlgrenska Fonden ("vi", "oss" eller "vår") förbinder sig att skydda din integritet och säkerheten för din personliga information. Denna integritetspolicy förklarar hur vi samlar in, använder, avslöjar och skyddar din personliga data i enlighet med gällande dataskyddslagar i Sverige.':
    "1. Introduction\n\nStiftelsen Kempe-Carlgrenska Fonden (“we,” “us,” or “our”) is committed to protecting the privacy and security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal data in accordance with the applicable data protection laws in Sweden.",
  "2. Information som Vi samlar in\n\nVi kan samla in och behandla följande typer av personlig information:\n- Kontaktinformation: Inkluderar ditt namn, e-postadress, postadress och telefonnummer.\n- Donationsinformation: Vi kan samla in information relaterad till dina donationer, inklusive betalningsuppgifter.\n- Användningsdata för Webbplats: Vi kan samla in data om dina besök på vår webbplats, som IP-adress, webbläsartyp, besökta sidor, och datum och tid för ditt besök.\n- Annan Information: All annan information som du frivilligt tillhandahåller i din interaktion med oss.":
    "2. Information We Collect\n\nWe may collect and process the following types of personal information:\n• Contact Information: This may include your name, email address, postal address, and phone number.\n• Donation Information: We may collect information related to your donations, including payment details.\n• Website Usage Data: We may gather data about your visits to our website, such as IP address, browser type, pages viewed, and the date and time of your visit.\n• Other Information: Any other information voluntarily provided by you in your interactions with us.",
  "3. Hur Vi Använder Din Information\n\nVi kan använda din personliga information för följande ändamål:\n- Att tillhandahålla information om våra verksamheter, evenemang och tjänster.\n- Att bearbeta donationer och erkänna ditt stöd.\n- Att svara på dina förfrågningar och begäranden.\n- Att förbättra vår webbplats och användarupplevelse.\n- Att följa lagliga skyldigheter.":
    "3. How We Use Your Information\n\nWe may use your personal information for the following purposes:\n• To provide information about our activities, events, and services.\n• To process donations and acknowledge your support.\n• To respond to your inquiries and requests.\n• To improve our website and user experience.\n• To comply with legal obligations.",
  "4. Delning och Avslöjande av Data\n\nVi säljer, byter eller hyr inte ut din personliga information till tredje parter. Vi kan dock dela dina uppgifter med:\n- Tjänsteleverantörer: Vi kan dela din information med betrodda tjänsteleverantörer som assisterar oss i våra verksamheter och tjänster.\n- Lagliga Krav: Vi kan avslöja din information för att uppfylla lagliga skyldigheter eller skydda våra rättigheter, integritet, säkerhet eller egendom.":
    "4. Data Sharing and Disclosure\n\nWe do not sell, trade, or rent your personal information to third parties. However, we may share your data with:\n• Service Providers: We may share your data with trusted service providers who assist us in carrying out our activities and services.\n• Legal Requirements: We may disclose your information to comply with legal obligations or protect our rights, privacy, safety, or property.",
  "5. Dina Rättigheter\n\nDu har rätt att:\n- Få tillgång till och rätta dina personuppgifter.\n- Återkalla ditt samtycke, där så är tillämpligt.\n- Begära radering av dina personuppgifter, i enlighet med lagliga krav.\n- Invända mot behandlingen av dina uppgifter under vissa omständigheter.":
    "5. Your Rights\n\nYou have the right to:\n• Access and rectify your personal data.\n• Withdraw your consent, where applicable.\n• Request the erasure of your personal data, subject to legal requirements.\n• Object to the processing of your data in certain circumstances.",
  "6. Säkerhetsåtgärder\n\nVi har implementerat rimliga säkerhetsåtgärder för att skydda din personliga information från obehörig åtkomst, avslöjande, ändring eller förstörelse.":
    "6. Security Measures\n\nWe have implemented reasonable security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.",
  "7. Kontaktinformation\n\nOm du har några frågor eller funderingar angående vår Integritetspolicy eller dina personuppgifter, vänligen kontakta oss på via kontaktformuläret.":
    "7. Contact Information\n\nIf you have any questions or concerns about our Privacy Policy or your personal data, please contact us at the contact form.",
  "8. Ändringar i Denna Policy\n\nVi kan uppdatera denna Integritetspolicy från tid till annan för att spegla förändringar i våra rutiner eller lagkrav. Eventuella uppdateringar kommer att publiceras på vår webbplats med angivande av det nya giltighetsdatumet.":
    "8. Changes to this Privacy Policy\n\nWe may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Any updates will be posted on our website with the effective date.",
  "Genom att använda våra tjänster och tillhandahålla din personliga information samtycker du till de metoder som beskrivs i denna Integritetspolicyoch godkänner behandlingen av dina uppgifter enligt dessa riktlinjer.\n\nStiftelsen Kempe-Carlgrenska Fonden\nHälsingegatan 31\n113 31, Stockholm":
    "By using our services and providing your personal information, you consent to the practices described in this Privacy Policy.\n\nStiftelsen Kempe-Carlgrenska Fonden\nHälsingegatan 31\n113 31, Stockholm",
  Om: "About",
  stiftelsen: "The Foundation",
  Stiftelsen: "Stiftelsen",
  Kempe: "Kempe",
  Carlgrenska: "Carlgrenska",
  Fonden: "Fonden",
  "Läs om Stiftelsens historia": "Learn about the history of the Foundation",
  "och grundare.": "and its founders.",
  "Vem var Fanny?": "Who was Fanny?",
  "Fanny Carlgren f. Kempe (1887- 1973) erhöll efter sin far Frans Kempe (vd Mo och Domsjö) ett stort arv och förvaltandet av arvet betraktade hon alltid som en mycket ansvarsfull uppgift. Detta arv lade grunden till Stiftelsen Kempe-Carlgrenska Fonden som stiftades den 28:e december 1951.":
    "Fanny Carlgren, née Kempe (1887-1973), was the daughter of Frans Kempe, who worked for several years first as the CEO and then as the chairman of Mo and Domsjö AB. After her father, Fanny Carlgren received a large inheritance, and she always considered the management of this inheritance a highly responsible task. This legacy also laid the foundation for The Kempe-Carlgrenska Foundation, established on December 28, 1951.",
  "Fanny Carlgren var intresserad av allt som gällde barn och ungdomar och de problem som kunde uppstå, vare sig det angick en organisation som arbetade med dessa eller om det gällde individen själv. De sista åren av hennes liv väckte narkotikaproblemet bland unga hennes engagemang.":
    "Fanny Carlgren was exceptionally interested, first and foremost, in everything concerning children and teenagers and the problems that could arise, whether it concerned an organization working with these groups or the individual themselves. In the last years of her life, the drug problem among the youth garnered her engagement.",
  "Efter startandet av föreningen ”Hem och skola” fick hon många framstående föreläsare till de offentliga debatter hon anordnade. Utbildning förblev ett av hennes huvudintressen och har erhållit ganska omfattande bidrag från stiftelsen både under Fanny Carlgrens ordförandetid och senare.":
    "She started an association, 'Home and School', in her time and brought many brilliant lecturers to the public debates she organized. Therefore, one of her main interests remained schools, and both Waldorf schools and other independent schools received quite extensive contributions from the foundation during Fanny Carlgren's chairmanship.",
  "Eftersom Fanny Carlgren var djupt religiös stod alltid ”kyrkan i centrum” för henne, dock långt ifrån kritiklöst. Hon var även en av dem som hjälpte Manfred Björkqvist att kunna fullgöra sitt livsverk – Sigtunastiftelsen.":
    "As Fanny Carlgren was deeply religious, the 'church was always central' to her, though far from uncritically. She was also one of those who helped Manfred Björkqvist fulfill his life's work – the Sigtuna Foundation.",
  "Fanny Carlgren var född till och förblev hela sitt liv en dotter av Norrland. Under hennes uppväxttid var Norrland Sveriges U-land och de frågor som rörde Norrland berörde henne alltid personligen.":
    "Fanny Carlgren was born and remained all her life a daughter of Norrland. During her upbringing, Norrland was Sweden's underdeveloped area, and the issues concerning Norrland always personally affected her.",
  Vård: "Care",
  av: "for",
  barn: "children",
  "Omvårdnad och stöd till barn med särskilda behov":
    "Care and support for children and young people with special needs",
  "Vilka kan söka och för vad?": "Who and for what can one apply?",
  "Från ändamålsparagrafen": "From the Purpose Paragraph",
  '"Att främja vård och uppfostran av barn"':
    '"To promote the care and upbringing of children"',
  "Sök bidrag": "Apply for grants",
  Ansökningsförfarande: "Application procedure",
  Ansökan: "Application",
  "Ansök under fliken Ansökningar ovan. Till ansökan tillfogas:":
    "Apply under the 'Applications' tab above. The following documents should be attached to your application:",
  "Två referenter. Bägge referenter ska vara någon med god kännedom om projektet som står utanför organisationen.":
    "Two referees. Both referees must have a good understanding of the project and be external to the organization.",
  "Budget för projektet": "Project budget",
  "Årsredovisning. Observera att bifogad årsredovisning även ska ha specificerade resultat- och balansräkningar som lämnar väsentlig information och är transparent gällande verksamheten. En årsredovisning som t ex summerar alla kostnader till en post ger oss inte denna information. Om sökandes bifogade årsredovisning lämnar alltför knapphändig information kommer vi att se detta som en ofullständig ansökan som inte kan tas upp till behandling.":
    "Annual report. Please note that the attached annual report must also include detailed income statements and balance sheets that provide essential information and are transparent about the organization's activities. An annual report that, for example, consolidates all expenses into a single line item does not offer this level of detail. If the applicant's attached annual report provides insufficient information, we will consider this an incomplete application that cannot proceed to evaluation.",
  Verksamhetsberättelse: "Activity report",
  Stadgar: "Bylaws",
  "Det finns två ansökningsperioder, februari och augusti. Ansökan kan endast göras inom dessa perioder. Då behandlingstiden är flera månader kan projektet påbörjas tidigast i juli samma år (för ansökningar inskickade i februari) samt i januari påföljande år (för ansökningar inskickade i augusti).":
    "There are two application periods, February and August. Applications can only be submitted during these periods. Since the processing time is several months, projects can start at the earliest in July of the same year (for applications submitted in February) and in January of the following year (for applications submitted in August).",
  "Det finns två ansökningsperioder, februari och augusti. Ansökan kan endast göras inom dessa perioder.":
    "There are two application periods, February and August. Applications can only be submitted during these periods.",
  Forskningsplan: "Research plan",
  "Rekommendationsbrev/Vitsord": "Letter of recommendation/Endorsement",
  "Intyg om institutionstillhörighet":
    "Certificate of Institutional Affiliation",
  "Sök forskningsstipendium": "Apply for research grant",
  "Lägg till signatur": "Insert signature",

  Vänligen: "Kindly",
  "Det finns två ansökningsperioder, februari och augusti. Ansökan kan endast göras inom dessa perioder. Du kan ansöka via fliken Ansökningar ovan.":
    "There are two application periods, February and August. Applications can only be made during these periods. You can apply from the Applications link above.",
  Utbildning: "Education",
  "Ladda ner mall för intyg": "Download certificate template",
  "Ladda ner exempel för Årsredovisning":
    "Download template for balance and income statement (Swedish only)",
  "Bidragsansökningar från organisationer/skolor för projekt som rör utbildning för barn och unga.":
    "Grant applications from organizations/schools for projects related to education for children and young people.",
  "Denna bidragskategori kan endast sökas av organisationer/skolor — inte av privatpersoner.":
    "This grant category can only be applied for by organizations/schools — not by private individuals.",
  "Stiftelsen beviljar inte ekonomiskt stöd till privatpersoner för personlig hjälp eller levnadskostnader.":
    "The foundation does not provide financial support to private individuals for personal assistance or living expenses.",
  "Som privatperson kan du endast söka stipendium inom musikstudier eller forskning enligt respektive kriterier.":
    "As a private individual, you can only apply for scholarships within music studies or research, according to the respective criteria.",
  "Om din förfrågan gäller personlig ekonomisk hjälp har vi tyvärr inte möjlighet att behandla den, och vi ber dig att inte skicka fler förfrågningar av den typen.":
    "If your inquiry concerns personal financial assistance, we unfortunately cannot process it, and we ask that you do not send further requests of that kind.",
  "Observera att ansökningar gällande skolresor, studieresor och konferenser etc inte prioriteras.":
    "Please note that applications regarding school trips, study trips, and conferences etc are not prioritized.",
  '"Att lämna understöd för beredande av undervisning eller utbildning"':
    '"To provide support for the provision of teaching or education"',
  Integrationsarbete: "Integration work for youth",
  "Stipendium ur Gösta Vestlunds Fond":
    "Scholarship from Gösta Vestlund's Fond",
  "Varje år delas 30 000 kr ut till en förening, verksamhet eller ungdomsledare som på ett för styrelsen föredömligt vis arbetar med integration av unga människor.":
    "Every year, 30,000 SEK is awarded to an association, operation, or youth leader who exemplarily works with the integration of young people, as determined by the board.",
  Hjälpbehövande: "People in Need",
  Hjälp: "People",
  be: "in",
  hövande: "Need",
  "Övrigt.": "Other.",
  "Stiftelsen fullföljer ändamålsbestämmelsen i denna del genom att själv utse årligt bidrag till ett av oss bestämt projekt i Asien, Afrika, Baltikum eller Sverige.":
    "The foundation fulfills its purpose in this part by annually designating a grant to one of our specific projects in Asia, Africa, the Baltic States, or Sweden.",
  '"Att utöva hjälpverksamhet bland behövande"':
    '"To carry out charitable activities among the needy"',
  "Privatpersoner såväl som organisationer kan inte själva ansöka om bidrag för ändamålet hjälpbehövande. Det finns därför inget ansökningsformulär.":
    "Individuals as well as organisations are not eligible to apply for grants for this purpose.",
  Forskning: "Research",
  "Forskning gällande barn och ungdom.":
    "Research concerning children and youth.",
  "Ansökningar från doktorander/post doc/forskare vars arbete är på hög vetenskaplig nivå och gällande barn eller ungdoms psykosociala situation och skolgång.":
    "Applications from doctoral students/post-doc/researchers whose work is at a high scientific level and concerning children or young people's psychosocial situation and schooling.",
  "Frågor och svar": "Questions and Answers",
  "Hur stort stipendiebelopp kan jag söka?":
    "How large a scholarship amount can I apply for?",
  "Vi ger doktorandstipendier om 18 000 kr/månad och Post-doc-stipendier om 25 000 kr/månad.":
    "We give doctoral scholarships of SEK 18,000 per month and post-doc scholarships of SEK 25,000 per month.",
  "Kan jag som forskare söka forskningsanslag?":
    "Can I, as a researcher, apply for research grants?",
  "Projektledaren bifogar CV, och institutionens prefekt intygar att projektet är välkommet vid institutionen.":
    "The project leader attaches a CV, and the institution's head of department certifies that the project is welcome at the institution.",
  "Anslaget avser i första hand direkta kostnader; max 10 % OH tillåts.":
    "The grant is primarily intended for direct costs; max 10% overhead is allowed.",
  "Bidrag är i första hand avsedda för att täcka direkta kostnader kopplade till projektets genomförande. Vi tillåter att en begränsad del av bidraget används för overheadkostnader (5-10%), men kräver då en detaljerad och tydlig redovisning av det totala bidragsbeloppet. Kostnader som inte är direkt kopplade till projektet, och som inte kan specificeras, kommer inte att godkännas":
    "Grants are primarily intended to cover direct costs associated with the implementation of the project. A limited portion of the grant (5-10%) may be used for overhead costs, but this requires a detailed and clear accounting of the total grant amount. Costs that are not directly related to the project and cannot be specified will not be approved.",
  "Musikstuderande på högskolenivå": "University Level Music Student",
  Musikstuderande: "Music-Students",
  på: "at",
  högskolenivå: "College-Level",
  "Våra anslag för musikstuderande på högskolenivå":
    "Our grants for music students at college level",
  Stipendier: "Scholarships",
  "Vad menas med ekonomisk redogörelse?":
    "What is meant by a financial statement?",
  Svenska: "English",
  "Det här är vår svenska sida":
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  Hej: "Hi",
  "Hej, välkommen tillbaka!": "Hi, welcome back!",
  "Logga in med": "Login with provider",
  "Vänligen logga in med ett Google konto för att komma till vår ansökningsportal. \nFör närvarande kan du endast logga in med ett Google konto.":
    "Please login to access our application platform. \nFor the time being you can only login with Google.",
  EDUCATION_DEVELOPMENT: "Education Development",
  UNIVERSITY_MUSIC_STUDENT: "University Level Music Student",
  CHILD_CARE_SUPPORT:
    "Care and support for children and young people with special needs",
  YOUTH_INTEGRATION_WORK: "Youth Integration Work",
  CHILD_YOUTH_RESEARCH: "Child and Youth Research",
  SUPPORT_NEEDY: "Support for the Needy",
  OTHER_QUESTIONS: "Other Questions",
  "Integrationsarbete för ungdom": "Youth Integration Work",
  "Forskning gällande barn och ungdom": "Child and Youth Research",
  "Understöd till hjälpbehövande": "Support for the Needy",
  "Övriga frågor": "Other Questions",
  "Kontakta oss": "Contact us",
  Kontakta: "Contact",
  Oss: "Us",
  "Skicka ett meddelande till Stiftelsen.": "Send a message to the Foundation.",
  Namn: "Namn",
  "Jag är en...": "I am a...",
  Ämne: "Topic",
  "Skicka meddelande": "Send message",
  "Tack! Vi har mottagit ditt meddelande":
    "Thank you, we have recieved your message",
  "Något gick fel, kontrollera alla fält och försök igen":
    "Something went wrong, check all fields and try again.",
  "Meddelande Skickat!": "Message sent!",
  Svara: "Reply",
  "Något gick fel!": "Something went wrong sending reply",
  "Din fråga:": "Your question:",
  Kontaktinformation: "Contact Information",
  "Här är dina senaste ansökningar och deras status.":
    "Here you can find your latest applications and their status.",
  "Här finns alla ansökningar. Filtrera och sök för att hitta ansökningar.":
    "Here are all the applications. Filter and search as needed.",
  "Styrelse och styrning": "Board & Governance",
  "Information om styrelsen kommer snart.": "Board information coming soon.",
  "Transparens och årsredovisningar": "Transparency & Annual Reports",
  "Här kan du läsa våra senaste årsredovisningar.":
    "Here you can read our latest annual reports.",
  "Ansök om anslag": "Apply for grants",
  "Ansökningar kan redigeras till slutet av ansökningsfönstret.":
    "Applications can be edited until our application window closes.",
  "Ansökan finns redan": "This application already exists",
  "Det finns redan en ansökan med de här uppgifterna i det här ansökningsfönstret. Varje sökande kan bara skicka in en ansökan per period.":
    "An application with these details has already been submitted in this application window. Each applicant may only submit one application per period.",
  "Visa befintlig ansökan": "View the existing application",
  "Redigera ansökan": "Edit application",
  Status: "Status",
  "Ansökt belopp": "Requested amount",
  "Ansökningsfönstret är stängt": "Application period closed",
  "Våra ansökningsfönster är 1 februari till 28 februari, och 1 augusti till 31 augusti varje år.":
    "Our application windows are February 1st to February 28th and August 1st to August 31st every year.",
  Datum: "Date",
  "Skapad den": "Created on",
  "Inga ansökningar": "No applications",
  "Skicka in ansökan": "Submit application",
  "Vänligen fyll i alla fält för ditt konto":
    "Please complete your profile first",
  "Saknar uppgifter": "Missing information",
  "Tack, vi har tagit emot din ansökan!":
    "Thank you, we have received your application!",
  "Något gick fel, vänligen kontrollera all fält är korrekt ifyllda":
    "Something went wrong, please check all fields are correctly filled in",
  "Vänligen fyll in följande formulär för att ansöka om anslag.":
    "Please fill in this form to apply for grants",
  utkast: "draft",
  inlämnad: "submitted",
  "under granskning": "under review",
  "behöver mer info": "needs more info",
  avslagen: "declined",
  "beviljat anslag": "grant given",
  DRAFT: "draft",
  SUBMITTED: "submitted",
  UNDER_REVIEW: "under review",
  NEEDS_MORE_INFO: "needs more info",
  DECLINED: "declined",
  GRANT_GIVEN: "grant given",
  Email: "Email",
  email: "email",
  applicationId: "Application number",
  "Tilldelat belopp": "Granted amount",
  "Personnummer (tolv siffror)":
    "Swedish personal identity number or coordination number (12 digits)",
  Adress: "Address",
  Postnummer: "Postal code",
  Ort: "City",
  "Belopp som söks från Stiftelsen Kempe-Carlgrenska Fonden (kronor)":
    "Requested amount (SEK)",
  "Plusgiro/bankgiro/bankkonto": "Bank account number",
  Kontohavare: "Bank account holder",
  "Uppgifter om sökanden": "Contact information",
  "Uppgifter om stipendiet och utbildningen": "Education and grant information",
  "Finansiell information": "Financial information",
  Referenter: "References",
  Bilagor: "Attachments",
  Instrument: "Instrument",
  "Nuvarande utbildning": "Current education",
  "Sökt utbildning": "Sougt education",
  "Jag studerar redan på samma utbildning":
    "I am already studying in the same program",
  "Jag är ännu inte antagen": "I have not yet been admitted",
  "Jag har blivit antagen för en kommande utbildning":
    "I have been admitted to an upcoming program",
  "Högre musikutbildning vid Kungl. Musikhögskolan ":
    "Högre musikutbildning vid Kungl. Musikhögskolan ",
  "Går första året i masterprogrammet.": "Går första året i masterprogrammet.",
  "Om du inte redan studerar, eller har blivit antagen på en utbildning måste du komplettera antagningsbesked i efterhand.":
    "If you are not already studying, or have been admitted to a program, you must supplement your admission decision afterwards.",
  Utbildningssituation: "Current status of your education",
  "Stipendiet kommer användas termin (höst/vår) och år":
    "Application is for year and term",
  "Har du tidigare erhållit bidrag från Stiftelsen Kempe-Carlgrenska Fonden?":
    "I have recieved grant(s) from KC-Fonden before",
  "Har organisationen tidigare erhållit bidrag från Stiftelsen Kempe-Carlgrenska Fonden?":
    "Has the organization received a grant from KC-Fonden before",
  "Organisation har tidigare erhållit bidrag från Stiftelsen Kempe-Fonden":
    "Organization has received grant(s) from KC-Fonden before",
  "Om ja, årtal (endast senaste anslag)": "Last Grant Year",
  "Vidtalad referent 1: namn": "Reference 1 Name",
  "Vidtalad referent 1: telefonnummer": "Reference 1 Phone Number",
  "Vidtalad referent 2: namn": "Reference 2 Name",
  "Vidtalad referent 2: telefonnummer": "Reference 2 Phone Number",
  "Underskrivet och skannat intyg (PDF)":
    "Signed and scanned certification (PDF)",
  "Ekonomisk redogörelse (PDF)": "Financial/Budget statement (PDF)",
  "Personligt brev (PDF)": "Personal letter (PDF)",
  "Eventuellt styrkande av erhållna CSN medel samt hur många veckor som återstår (PDF)":
    "Certificate of obtained CSN grants and how many weeks are left (PDF, optional)",
  "Antagningsbesked eller intyg om studieplats (PDF)":
    "Admission Certification or Proof of Enrollment (PDF, optional)",
  "Officiellt dokument från din utbildning som visar att du studerar eller kommer studera på den angivna utbildningen. Om du inte redan studerar på utbildningen, eller ännu inte har blivit antagen, kommer ett eventuellt stipendieanslag endast delas ut efter att antagningsbesked i efterhand kompletterats.":
    "Official document from your education that shows that you are studying or will study at the specified education. If you are not already studying in the program, or have not yet been admitted, any potential scholarship award will only be distributed after the admission notice has been supplemented afterwards.",
  Sammanfattning: "Summary",
  "Sammanfattning av sökandens presentation innehållande nuvarande studiesituation samt vad stipendiet ska användas till (max 3400 tecken, ungefär 500 ord)":
    "Summary of the applicant's presentation, including their current study situation and how the grant will be used (max 3400 characters, approximately 500 words).",
  "Uppgifter om projectet och forskningsinstitutionen":
    "Research project and institution",
  Forskarstatus: "Current Research Status",
  "Forskningen utförs vid institutionen för": "Institution",
  "Institutionens administrativa chef/ekonomiskt ansvarige: namn":
    "Administrator Name",
  "Institutionens administrativa chef/ekonomiskt ansvarige: telefonnummer":
    "Administrator Phone",
  "Välj projektnivå": "Choose project level",
  "Välj årtal": "Choose year",
  Projektnivå: "Project Level",
  Projekttitel: "Project Title",
  "Forskningsplan, specifikation av sökta medel och CV (PDF)":
    "Research Plan (PDF)",
  "Rekommendationsbrev/vitsord (PDF)": "Recommendation letter (PDF)",
  "Intyg om institutionstillhörighet (PDF)":
    "Affiliation Certification (PDF, optional)",
  "Sammanfattning av projektet, idé och syfte (max 3400 tecken, ungefär 500 ord)":
    "Summary of the project, including its idea and purpose (max 3400 characters, approximately 500 words).",
  Licentiatprojekt: "Licentiate project",
  Doktorandprojekt: "Doctoral project",
  "Post-doc-projekt": "Post-doc project",
  "Projekt av hög vetenskaplig nivå": "Project of high scientific level",
  LICENTIATE_PROJECT: "Licentiate project",
  DOCTORAL_PROJECT: "Doctoral project",
  POST_DOC_PROJECT: "Post-doc project",
  PROJECT_OF_HIGH_SCIENTIFIC_LEVEL: "Project of high scientific level",
  SPRING: "spring",
  SUMMER: "summer",
  FALL: "fall",
  WINTER: "winter",
  "Uppgifter om organisationen": "Contact information",
  "Uppgifter om projektet": "Project and grant information",
  "Organisationens namn": "Organization Name",
  "Namn/företrädare": "Representative Name",
  Organisationsnummer: "Organization Number",
  "Budget för projektet (PDF eller Excel)": "Project Budget (PDF)",
  "Årsredovisning (balansräkning och resultaträkning) (PDF eller Excel)":
    "Annual Report (PDF)",
  "Verksamhetsberättelse (PDF)": "Activity Report (PDF)",
  "Stadgar (PDF)": "Organization bylaws (PDF)",
  "Ja, vi har tagit del av informationen ovan":
    "Yes, we understand and accept the information above.",
  "Bifogad årsredovisning skall även ha specificerade resultat-och balansräkningar som lämnar väsentlig information och är transparent gällande verksamheten. En årsredovisning som tex summerar alla kostnader till en post ger för oss ingen sådan värdefull information. Om sökandes bifogade årsredovisning lämnar alltför knapphändig information kommer vi att se detta som en ofullständig ansökan som inte kan tas upp till behandling.":
    "The attached annual report must also have specified income statements and balance sheets that provide substantial information and are transparent regarding the operations. \n\nAn annual report that, for example, summarizes all costs into one item does not provide such valuable information to us. \n\n If the applicant's attached annual report provides too scant information, we will consider this as an incomplete application that cannot be processed.",
  "Sammanfattning av projektet (max 3400 tecken, ungefär 500 ord)":
    "Summary of the project (max 3400 characters, approximately 500 words).",
  "Här är dina Tidigare rapporter.":
    "Here you can find your latest reports and their status.",
  "Ny rapport": "New report",
  Redigera: "Edit",
  "Redigera rapport": "Redigera rapport",
  "Inga rapporter": "No reports",
  "Mål och resultat": "Goal and Results",
  "Tack, vi har tagit emot din rapport!":
    "Thank you, we have received your report!",
  "Skicka in rapport": "Send report",
  År: "Year",
  Termin: "Term",
  "Allmäna uppgifter": "General Information",
  "Vänligen beskriv de mål och resultat som uppnåtts.":
    "Please describe the goals and results achieved.",
  "Bilaga (endast PDF), frivilligt": "Attachment (PDF only), optional",
  "Institutionens namn": "Name of Institution",
  Bakgrund: "Background",
  Syfte: "Purpose",
  Metod: "Method",
  Resultat: "Results",
  "Redigera konto": "Edit account",
  "Här kan du ändra eller lägga till information för ditt användarkonto.":
    "Here you can edit information about your account.",
  "Sparat!": "Saved!",
  "Något gick fel, kontrolla alla fält och försök igen":
    "Something went wrong, check the fields and try again!",
  Spara: "Save",
  "Ladda upp filer": "Upload files",
  "Släpp eller välj fil": "Drop or Select file",
  "Släpp en fil här eljer välj en fil genom att klicka här":
    "Drop files here or click browse thorough your machine",
  användare: "user",
  mejladress: "email address",
  kontotyp: "account type",
  musiker: "musician",
  forskare: "researcher",
  organisation: "organization",
  MUSICIAN: "Musician",
  RESEARCHER: "Researcher",
  ORGANIZATION: "Organization",
  OTHER: "other",
  annan: "other",
  ja: "yes",
  nej: "no",
  Ja: "Yes",
  Nej: "No",
  "Ny användare": "create user",
  öppna: "open",
  "Tyvärr kunde vi inte hitta sidan du efterfrågade. Kanske är adresses felstavad?":
    "Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.",
  "Gå till startsidan": "Go to home",
  "Logga in till KC-Fonden": "Sign in to KC-Fonden",
  Lista: "List",
  "skapa användare": "Create user",
  redigera: "edit",
  handla: "shop",
  blogg: "blog",
  inlägg: "posts",
  meddelande: "message",
  kort: "cards",
  "ny ansökan": "New application",
  "Ny ansökan": "New application",
  "Tidigare ansökningar": "Previous applications",
  "Tidigare rapporter": "Previous reports",
  "ny rapport": "New report",
  allmän: "general",
  bank: "banking",
  bokning: "booking",
  profil: "profile",
  Konto: "Account",
  produkt: "product",
  kvitto: "invoice",
  detaljer: "details",
  kassa: "checkout",
  kalender: "calendar",
  Bedömningsmallar: "Assessment Templates",
  "Skapa bedömningsmall": "Create assessment template",
  "Redigera bedömningsmall": "Edit assessment template",
  "System prompt": "System prompt",
  "Skapa en bedömningsmall för att bedöma ansökningar":
    "Create an assessment template to assess applications",
  "Redigera bedömningsmallen": "Edit the assessment template",
  "Skapa och hantera bedömningsmallar":
    "Create and manage assessment templates",
  "Visa AI-bedömningar": "Hide AI assessments",
  "Synkroniserar...": "Syncing...",
  "Sparar...": "Saving...",
  "Migrera Google Drive": "Migrate Google Drive",
  "Synkronisera Google Drive till Google Bucket":
    "Sync Google Drive to Google Bucket",
  "Inställningar för administratörer": "Admin settings",
  "Klart!": "Done!",
  "Vänligen försök igen senare.": "Please try again later.",
  "Ta bort bedömningsmall": "Delete assessment template",
  "Är du säker på att du vill ta bort denna bedömningsmall?":
    "Are you sure you want to delete this assessment template?",
  "När fick du bidrag senast?": "When did you receive a grant before?",
  "Ta bort": "Delete",
  "Borttagen!": "Deleted!",
  Mall: "Template",
  För: "For",
  Skapad: "Created",
  Analys: "Analytics",
  Administration: "Administration",
  "e-handel": "e-commerce",
  Hantering: "management",
  Meddelanden: "messages",
  Inkorg: "Inbox",
  Skickat: "Sent",
  "Ljust/Mörkt": "Light/Dark",
  Ljust: "Light",
  Automatiskt: "Auto",
  Mörkt: "Dark",
  Färger: "Presets",
  Inställningar: "Settings",
  Helskärm: "Full-screen",
  "Avluta helskärm": "Exit full-screen",
  menynivå: "menu level",
  "menynivå 2a": "menu level 2a",
  "menynivå 2b": "menu level 2b",
  "menynivå 3a": "menu level 3a",
  "menynivå 3b": "menu level 3b",
  "menynivå 4a": "menu level 4a",
  "menynivå 4b": "menu level 4b",
  "enhet avstängd": "item disabled",
  etikett: "item label",
  "enhet undertext": "item caption",
  "enhet extern länk": "item external link",
  beskrivning: "description",
  "andra fall": "other cases",
  "enheter per roll": "item by roles",
  "Endast administratörer kan se denna enhet": "Only admin can see this item",
  "Logga in som admin": "Login as admin",
  "läs mer": "read more",
  vår: "spring",
  sommar: "summer",
  höst: "fall",
  vinter: "winter",
  "Ta Bort": "Remove",
  "Ta bort alla filer": "Remove all files",
  "Fil Borttagen": "File Removed",
  "Filen finns inte, eller så får du inte ta bort den":
    "File doesn't exist, or you don't have permission to remove it",
  "spara alla filer": "download all files",
  Öppna: "download",
  "Fil nedladdad": "File downloaded",
  "Något gick fel, kunde inte hitta filen":
    "File doesn't exist, or you don't have permission to view it",
  Hem: "Home",
  Anslag: "Grants",
  Studenter: "Musicians",
  Musikstudenterande: "Students",
  Forskare: "Researchers",
  "Forskning kring barn och ungdomar": "Research on children and adolescents",
  Organisationer: "Organizations",
  "Barn med särskilda behov": "Children and young people with special needs",
  Övrigt: "Other",
  "Den sidan finns inte.": "Sorry that page isn’t here.",
  "Vi kunde inte hitta sidan du letade efter. Kanske är adressen felstavad? Var god kontrollera stavningen och försök igen.":
    "We couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.",
  "Skriv svar här": "Write your reply here",
  Verifieringsmailer: "Verification mailer",
  "Administratörer kan ansluta en Google-inkorg för verifieringsmejl.":
    "Admins can connect a Google inbox for verification emails.",
  "Google-kontot är nu anslutet.": "Google account connected successfully.",
  "Anslutning misslyckades": "Connection failed",
  "Inte ansluten": "Not connected",
  "Återanslut krävs": "Needs reauth",
  Inaktiverad: "Disabled",
  "Status:": "Status:",
  "From:": "From:",
  "Senast lyckad:": "Last success:",
  "Senast fel:": "Last failure:",
  "Error:": "Error:",
  "Anslut/Återanslut Google": "Connect/Reconnect Google",
  "Få varningsmejl vid integrationsfel":
    "Receive alert emails on integration failures",
  "Endast administratörer som aktiverat detta får varningsmejl.":
    "Only admins who enable this setting will receive alert emails.",
  "Skicka testmejl till": "Send test email to",
  "Testmejl misslyckades": "Test email failed",
  "Testmejl skickat.": "Test email sent.",
  "Skicka testmejl": "Send test email",
  "Skickar...": "Sending...",
  "Mailer-integration behöver åtgärd": "Mailer integration needs attention",
  "Systemet har upptäckt problem med mailer-integrationen.":
    "The system detected an issue with the mailer integration.",
  "Öppna mailer-inställningar": "Open mailer settings",
  "Redigera banner": "Edit banner",
  HTML: "HTML",
  Variant: "Variant",
  Titel: "Title",
  Innehåll: "Content",

  // zod translations
  Required: "Required",
  "Too small: expected string to have >=1 characters": "Required",
  "Too small: expected string to have >=20 characters":
    "Too short: min 20 characters",
  "Too small: expected string to have >=100 characters":
    "Too short: min 100 characters",
  "Too small: expected string to have >=200 characters":
    "Too short: min 200 characters",
  "Too big: expected string to have <=3400 characters":
    "Too long. Must contain at most 3400 character(s)",
  "not a valid email address": "Invalid email",
  "Invalid email address": "Invalid email address",
  "Invalid input": "Invalid input",
  "Invalid email": "Invalid email",
  "Invalid enum value. Expected 'MUSICIAN' | 'ORGANIZATION' | 'RESEARCHER' | 'OTHER', received ''":
    "Invalid account type",
  "Invalid enum value. Expected 'EDUCATION_DEVELOPMENT' | 'UNIVERSITY_MUSIC_STUDENT' | 'CHILD_CARE_SUPPORT' | 'YOUTH_INTEGRATION_WORK' | 'CHILD_YOUTH_RESEARCH' | 'SUPPORT_NEEDY' | 'OTHER_QUESTIONS', received ''":
    "Invalid option",
  "Invalid enum value. Expected 'FALL' | 'SPRING', received ''": "Select term",
  "Name is required": "Name is required",
  "Year must be a whole number": "Invalid year",
  "Please select account type": "Please select account type",
  "Invalid format. Enter twelve digits: YYYYMMDD-XXXX, e.g. 19950101-1234":
    "Invalid format. Enter twelve digits: YYYYMMDD-XXXX, e.g. 19950101-1234",
  "String must contain at least 3 character(s)": "Too short",
  "Must be exactly 5 digits": "Must be exactly 5 digits",
  "Invalid postal code format": "Invalid postal code format",
  "Research status must be at least 1 character long":
    "Forskarstatus måste vara minst 1 tecken långt",
  "Expected boolean, received string": "Invalid option",
  "Expected number, received string": "Expected number, received string",
  "Invalid project level": "Invalid project level",
  "Invalid enum value. Expected 'LICENTIATE_PROJECT' | 'DOCTORAL_PROJECT' | 'POST_DOC_PROJECT' | 'PROJECT_OF_HIGH_SCIENTIFIC_LEVEL', received ''":
    "Invalid project level",
  "Number must be greater than or equal to 1000":
    "Requested amount must be at least 1,000 SEK",
  "Only numbers": "Only numbers",
  "Invalid organisation number format. Format is 123456-1234":
    "Invalid organisation number format. Format is 123456-1234",
  "Invalid phone number. Format can include country code like +46701234567":
    "Invalid phone number. Phone number can include country code like +46701234567",
  "Invalid url": "Invalid file. Please make sure you have attached a file",
  "Expected string, received null":
    "Invalid file. Please make sure you have attached a file",
  "Invalid enum value. Expected 'MUSICIAN' | 'ORGANIZATION' | 'RESEARCHER', received ''":
    "Invalid account type",
  "Nytt meddelande": "New message",
  "Nytt meddelande från": "New message from",
  "Namn: ": "Name: ",
  "Övriga bilagor": "Other attachments",
  "Övriga bilagor (PDF eller Excel)": "Other attachments (PDF or Excel)",
  "Behöver du bifoga övriga bilagor för att ge en fullgod ansökan, kan du bifoga de här.":
    "Need to attach other documents in order to get a full grant. You can attach them here.",
  "Email: ": "Email: ",
  "Meddelande: ": "Message: ",
  "Besök kc-fonden.se": "Visit kc-fonden.se",
  Meny: "Menu",
  id: "ID",
  createdAt: "Created (Date)",
  updatedAt: "Updated (Date)",
  createdById: "Created By ID",
  updatedById: "Updated By ID",
  createdBy: "Created By",
  updatedBy: "Updated By",
  kind: "Type",
  emailAddress: "Email Address",
  name: "Name",
  address: "Address",
  postalCode: "Postal Code",
  city: "City",
  receivedGrantBefore: "Received Grant Before",
  lastGrantYear: "Last Grant Year",
  requestedAmount: "Requested Amount",
  bankAccountNumber: "Bank Account Number",
  bankAccountHolder: "Bank Account Holder",
  projectSummary: "Project Summary",
  signedCertUrl: "Signed Certificate URL",
  status: "Status",
  grantedAmount: "Granted Amount",
  personalNumber: "Personal Number",
  researchStatus: "Research Status",
  institution: "Institution",
  adminName: "Administrator's Name",
  adminPhone: "Administrator's Phone",
  projectLevel: "Project Level",
  projectTitle: "Project Title",
  researchPlanUrl: "Research Plan URL",
  recommendationUrl: "Recommendation Letter URL",
  affiliationCertUrl: "Affiliation Certificate URL",
  instrument: "Instrument",
  currentEducation: "Current Education",
  soughtEducation: "Sought Education",
  educationSituation: "Education Situation",
  termAndYear: "Term and Year",
  reference1Name: "Reference 1 Name",
  reference1Phone: "Reference 1 Phone",
  reference2Name: "Reference 2 Name",
  reference2Phone: "Reference 2 Phone",
  financialStatementUrl: "Financial Statement URL",
  personalLetterUrl: "Personal Letter URL",
  CSNCertUrl: "CSN Certificate URL",
  admissionCertUrl: "Admission Certificate URL",
  orgName: "Organization Name",
  representativeName: "Representative's Name",
  orgNumber: "Organization Number",
  projectBudgetUrl: "Project Budget URL",
  annualReportUrl: "Annual Report URL",
  activityReportUrl: "Activity Report URL",
  otherAttachmentsUrl: "Other Attachments URL",
  otherAttachmentUrl: "Övriga bilagor URL",
  bylawsUrl: "Bylaws URL",
  acceptedTerms: "Accepted Terms",
  "You must accept the terms": "You must accept the terms",
  grantYear: "Grant Year",
  grantSemester: "Grant Semester",
  summary: "Summary",
  attachments: "Attachments",
  timestamp: "Timestamp",
  visitorId: "Visitor's ID",
  pageVisited: "Page Visited",
  userAgent: "User Agent",
  ipAddress: "IP Address",
  country: "Country",
  region: "Region",
  referer: "Referer",
  true: "Yes",
  false: "No",
  Avbryt: "Cancel",
  "Är du säker på att du vill skicka detta svar?":
    "Are you sure you want to send this reply?",
  "Välkommen tillbaka": "Welcome back",
  "Det här är Stiftelsen Kempe-Carlgrenska Fonden's Dashboard, som ger insikter om våra användare och ansökningstrender.":
    "This is Stiftelsen Kempe-Carlgrenska Fonden's Dashboard, which provides insights into our users and application trends.",
  "Besökare (månadsvis)": "Visitors (total/per month)",
  "Nya användare (månadsvis)": "Registered users (total/per month)",
  "Meddelanden (månadsvis)": "Messages (total/per month)",
  "Svarade meddelanden (månadsvis)": "Replied messages (total/per month)",
  "Ansökningar (totalt)": "Applications (total)",
  Månadsvis: "Monthly",
  Årsvis: "Yearly",
  Halvårsvis: "Semi-yearly",
  "Svaret måste vara minst 20 tecken": "Reply must be at least 20 characters",
  "Följande fält verkar inte vara korrekt ifyllda:":
    "The following fields are not filled correctly:",
  Problem: "Problems",
  Starttid: "Start time",
  Sluttid: "End time",
  "AI-utkast klart": "AI draft ready",
  "Infoga AI-utkast": "Insert AI draft",
  "Genererar AI-utkast…": "Generating AI draft…",
  "AI-utkast misslyckades": "AI draft failed",
  "Generera AI-utkast": "Generate AI draft",
  "Regenerera AI-utkast": "Regenerate AI draft",
  "Regenerera AI-utkast?": "Regenerate AI draft?",
  "Detta kommer att ersätta det befintliga AI-utkastet.":
    "This will replace the existing AI draft.",
  "Skicka?": "Send?",
  "Fel: kunde inte läsa bilaga": "ERROR: Could not parse attachment",
  // Texter uppdaterade augusti 2026 (Cecilias slutliga förslag)
  Ansökningsperioder: "Application periods",
  "Det finns två ansökningsperioder per år:":
    "There are two application periods each year:",
  Februari: "February",
  Augusti: "August",
  "Ansökan kan endast skickas in under dessa perioder.":
    "Applications can only be submitted during these periods.",
  "Ansökan i februari": "Applying in February",
  "Ansökan i augusti": "Applying in August",
  "Ansökan görs via fliken Ansökningar.":
    "Applications are submitted via the Applications tab.",
  "Doktorand- och post-docstipendier": "Doctoral and post-doc scholarships",
  "KC-Fonden tar emot ansökningar från doktorander och post-doc-forskare vars forskningsarbete håller hög vetenskaplig nivå och handlar om barns eller ungdomars psykosociala situation och/eller skolgång.":
    "KC-Fonden accepts applications from doctoral students and post-doc researchers whose research is of a high scientific standard and concerns the psychosocial situation and/or schooling of children or young people.",
  "För närvarande är stipendiebeloppen:":
    "The current scholarship amounts are:",
  "Doktorand: 18 000 kr per månad": "Doctoral student: SEK 18,000 per month",
  "Post-doc: 25 000 kr per månad": "Post-doc: SEK 25,000 per month",
  "Stipendierna är personliga och avsedda att stödja doktorandens utbildning på forskarnivå respektive post-doc-forskarens postdoktorala meritering.":
    "The scholarships are personal and intended to support the doctoral student's postgraduate education and the post-doc researcher's postdoctoral qualification, respectively.",
  Forskningsanslag: "Research grants",
  "KC-Fonden kan även bevilja forskningsanslag till forskningsprojekt där projektledaren är disputerad.":
    "KC-Fonden may also award research grants to research projects where the project leader holds a doctorate.",
  "Till ansökan ska projektledaren bifoga sitt CV. Institutionens prefekt ska också intyga att projektet är välkommet vid institutionen.":
    "The project leader must attach their CV to the application. The head of the department must also certify that the project is welcome at the department.",
  "Till ansökan ska en budget bifogas där det framgår hur det sökta anslaget är tänkt att användas. KC-Fonden detaljreglerar inte fördelningen mellan olika kostnadsslag inom det beviljade forskningsprojektet.":
    "A budget must be attached to the application, showing how the requested grant is intended to be used. KC-Fonden does not regulate in detail how funds are allocated between cost categories within the approved research project.",
  "Högst 10 procent overhead (OH) får belasta anslaget.":
    "A maximum of 10 percent overhead (OH) may be charged to the grant.",
  "Nödvändiga resor som är direkt kopplade till forskningsprojektets genomförande kan ingå i anslaget. Konferensresor omfattas inte.":
    "Necessary travel directly linked to carrying out the research project may be included in the grant. Conference travel is not covered.",
  "Ansökan görs via fliken Ansökningar ovan.":
    "Applications are submitted via the Applications tab above.",
  "Förutom ansökningsformuläret ska följande dokument bifogas:":
    "In addition to the application form, the following documents must be attached:",
  "Viktigt om bankkonto": "Important information about bank accounts",
  "Om du söker doktorand- eller post-docstipendium ska du ange ditt eget plusgiro, bankgiro eller bankkonto för utbetalningen.":
    "If you apply for a doctoral or post-doc scholarship, you must provide your own plusgiro, bankgiro or bank account for the payment.",
  "Stipendiet ska inte betalas till forskningsinstitutionens bankgiro eller plusgiro, eftersom stipendiet inte är avsett att täcka institutionens overheadkostnader.":
    "The scholarship must not be paid to the research institution's bankgiro or plusgiro, as the scholarship is not intended to cover the institution's overhead costs.",
  "Detta gäller inte forskningsanslag. För forskningsanslag kan utbetalningen hanteras av den institution där projektet bedrivs.":
    "This does not apply to research grants. For research grants, the payment can be handled by the institution where the project is carried out.",
  "Kan jag söka bidrag för en konferensresa?":
    "Can I apply for funding for a conference trip?",
  "Nej. Konferensresor omfattas inte av forskningsanslaget. Nödvändiga resor som är direkt kopplade till forskningsprojektets genomförande kan däremot ingå.":
    "No. Conference travel is not covered by the research grant. However, necessary travel directly linked to carrying out the research project may be included.",
  "Behöver jag redovisa hur stipendiet eller forskningsanslaget har använts?":
    "Do I need to report how the scholarship or research grant has been used?",
  "Ja. När stipendieperioden eller forskningsprojektet är avslutat ska du lämna en kort redogörelse för resultatet och hur stipendiet eller forskningsanslaget har använts.":
    "Yes. When the scholarship period or research project has ended, you must submit a brief report on the results and how the scholarship or research grant has been used.",
  "Redogörelsen lämnas via KC-Fondens ansökningsplattform och är obligatorisk.":
    "The report is submitted via KC-Fonden's application platform and is mandatory.",
  Musikstipendier: "Music scholarships",
  "KC-Fonden delar ut stipendier till studerande på högskolenivå inom musik.":
    "KC-Fonden awards scholarships to university-level music students.",
  "Stipendierna är avsedda för kommande studier och kan endast sökas för en studieperiod som ännu inte har påbörjats.":
    "The scholarships are intended for upcoming studies and can only be applied for in respect of a study period that has not yet begun.",
  "Stipendier beviljas inte retroaktivt. Det innebär att redan avslutade studier inte kan finansieras.":
    "Scholarships are not awarded retroactively. This means that already completed studies cannot be funded.",
  "Stipendierna är normalt på 10 000–20 000 kronor.":
    "Scholarships are normally SEK 10,000–20,000.",
  "Det finns ingen fast övre gräns för vilket belopp du kan söka. I vissa fall kan ett högre belopp beviljas efter en samlad bedömning av ansökan och den sökandes studiesituation.":
    "There is no fixed upper limit on the amount you can apply for. In some cases a higher amount may be awarded after an overall assessment of the application and the applicant's study situation.",
  "Vi ger i första hand stipendier till instrumentalister.":
    "We primarily award scholarships to instrumentalists.",
  "Vad kan stipendiet användas till?": "What can the scholarship be used for?",
  "Stipendiet är avsett för studier och utbildning. Kostnaderna ska ha en tydlig koppling till den sökandes musikstudier.":
    "The scholarship is intended for studies and education. The costs must be clearly linked to the applicant's music studies.",
  "KC-Fonden beviljar inte stipendier för inköp av instrument eller annan utrustning. Det gäller även inköp av ett nytt instrument, byte till ett bättre instrument eller uppgradering av ett befintligt instrument.":
    "KC-Fonden does not award scholarships for the purchase of instruments or other equipment. This also applies to buying a new instrument, switching to a better instrument or upgrading an existing instrument.",
  "Stipendiet ska alltså användas för att stödja den sökandes musikstudier och inte för att finansiera instrumentköp.":
    "The scholarship must therefore be used to support the applicant's music studies, not to finance instrument purchases.",
  "Ansökan kan endast göras under dessa perioder.":
    "Applications can only be made during these periods.",
  "I februari kan du söka stipendium för studier som tidigast påbörjas i juli samma år.":
    "In February you can apply for a scholarship for studies starting in July of the same year at the earliest.",
  "I augusti kan du söka stipendium för studier som tidigast påbörjas under vårterminen året därpå.":
    "In August you can apply for a scholarship for studies starting in the spring term of the following year at the earliest.",
  "Handlingar som ska bifogas": "Documents to attach",
  "1. Personligt brev": "1. Personal letter",
  "Bifoga ett personligt brev med en kort presentation av dig själv och din nuvarande studiesituation.":
    "Attach a personal letter with a short presentation of yourself and your current study situation.",
  "Brevet får vara högst en A4-sida.": "The letter may be at most one A4 page.",
  "2. Uppgift om CSN": "2. CSN information",
  "Ange hur många veckor du har kvar med möjlighet att få studiemedel från CSN.":
    "State how many weeks of eligibility for student finance (CSN) you have left.",
  "Uppgiften om CSN ingår i den samlade bedömningen av ansökan. Begränsade eller uttömda möjligheter till studiemedel kan vägas in i bedömningen.":
    "The CSN information is part of the overall assessment of the application. Limited or exhausted student finance options may be taken into account.",
  "Stipendiet är däremot inte avsett att ersätta CSN-lån som den sökande väljer att avstå från.":
    "However, the scholarship is not intended to replace CSN loans that the applicant chooses to forgo.",
  "3. Ekonomisk redogörelse": "3. Financial statement",
  "Bifoga en ekonomisk redogörelse eller budget för din ekonomi. Redovisa både inkomster och utgifter.":
    "Attach a financial statement or budget for your finances. Report both income and expenses.",
  "Redogörelsen får vara högst en A4-sida.":
    "The statement may be at most one A4 page.",
  "Du kan redovisa ekonomin månadsvis eller sammanställt för den period som är relevant för ansökan.":
    "You can present your finances month by month or summarised for the period relevant to the application.",
  "Det är viktigt att även ange om du har fått eller förväntas få stipendier eller andra ekonomiska bidrag från annat håll under den period som redovisningen avser.":
    "It is important to also state whether you have received, or expect to receive, scholarships or other financial support from elsewhere during the period covered by the statement.",
  "4. Två referenter": "4. Two references",
  "Ange två personer som kan lämna referens om dig.":
    "Provide two people who can give a reference about you.",
  "I första hand ser vi gärna att minst en av referenterna är din lärare.":
    "We prefer that at least one of the references is your teacher.",
  "Referenternas telefonnummer ska anges enligt uppgifterna i ansökningsformuläret.":
    "The references' phone numbers must be provided as specified in the application form.",
  "Vad menas med referent?": "What is meant by a reference?",
  "Med referent menar vi en person som känner till dig och dina studier och som kan lämna en rekommendation.":
    "By reference we mean a person who knows you and your studies and can provide a recommendation.",
  "I första hand ser vi gärna att referenten är lärare.":
    "We prefer that the reference is a teacher.",
  "Du ska redovisa dina inkomster och utgifter.":
    "You must report your income and expenses.",
  "Kom ihåg att även redovisa eventuella stipendier eller andra ekonomiska bidrag som du har fått eller förväntas få under samma period.":
    "Remember to also report any scholarships or other financial support you have received or expect to receive during the same period.",
  "Hur stort stipendium kan jag söka?":
    "How large a scholarship can I apply for?",
  "Det finns ingen fast gräns för hur stort belopp du kan söka.":
    "There is no fixed limit on the amount you can apply for.",
  "KC-Fonden beviljar vanligtvis stipendier på 10 000–20 000 kronor. I vissa fall kan ett högre belopp beviljas efter en samlad bedömning av ansökan och den sökandes studiesituation.":
    "KC-Fonden usually awards scholarships of SEK 10,000–20,000. In some cases a higher amount may be awarded after an overall assessment of the application and the applicant's study situation.",
  "Kan jag söka stipendium för att köpa ett instrument?":
    "Can I apply for a scholarship to buy an instrument?",
  "Nej. KC-Fonden beviljar inte stipendier för inköp av instrument eller annan utrustning. Det gäller även om instrumentet behövs för dina studier eller om du vill köpa ett bättre instrument.":
    "No. KC-Fonden does not award scholarships for the purchase of instruments or other equipment. This also applies if the instrument is needed for your studies or if you want to buy a better instrument.",
  "Behöver jag redovisa hur stipendiet har använts?":
    "Do I need to report how the scholarship has been used?",
  "Ja. Senast tre månader efter att den studieperiod eller utbildning som stipendiet avser har avslutats ska du lämna en kort redogörelse för dina studieresultat, hur studierna har gått och hur stipendiet har använts.":
    "Yes. No later than three months after the end of the study period or education the scholarship relates to, you must submit a brief report on your study results, how your studies have gone and how the scholarship has been used.",
  "Redogörelsen lämnas via KC-Fondens ansökningsplattform på hemsidan och är obligatorisk.":
    "The report is submitted via KC-Fonden's application platform on the website and is mandatory.",
  "KC-Fonden kan ge bidrag till organisationer som arbetar med omvårdnad och stöd till barn och ungdomar med särskilda behov, inklusive organisationer som arbetar med barn och ungdomar med funktionsnedsättning.":
    "KC-Fonden can provide grants to organisations working with the care and support of children and young people with special needs, including organisations working with children and young people with disabilities.",
  "Bidragen kan avse olika typer av insatser och projekt som syftar till att ge barn och ungdomar bättre stöd, omvårdnad eller förutsättningar för en fungerande vardag.":
    "Grants may cover various types of initiatives and projects aimed at giving children and young people better support, care or the conditions for a functioning everyday life.",
  "Vilka projekt prioriteras?": "Which projects are prioritised?",
  "KC-Fonden ger i första hand bidrag till nya projekt som ännu inte har genomförts.":
    "KC-Fonden primarily awards grants to new projects that have not yet been carried out.",
  "Vi prioriterar särskilt pilotprojekt, det vill säga nya eller prövande insatser där ett nytt arbetssätt eller en ny verksamhet prövas.":
    "We particularly prioritise pilot projects, i.e. new or exploratory initiatives where a new way of working or a new activity is being tried out.",
  "Bidrag till redan etablerad eller löpande verksamhet prioriteras normalt inte.":
    "Grants for already established or ongoing activities are normally not prioritised.",
  "Att en organisation tidigare har fått bidrag från KC-Fonden hindrar inte organisationen från att ansöka på nytt. Vid bedömningen prioriteras dock i första hand nya projekt framför fortsatt finansiering av redan etablerad verksamhet.":
    "Having previously received a grant from KC-Fonden does not prevent an organisation from applying again. However, in the assessment, new projects are prioritised over continued funding of already established activities.",
  "Följande dokument och uppgifter ska bifogas:":
    "The following documents and information must be attached:",
  "1. Två externa referenter": "1. Two external references",
  "Ange två personer som:": "Provide two people who:",
  "har god kännedom om projektet eller den verksamhet som ansökan gäller, och":
    "have good knowledge of the project or the activities the application concerns, and",
  "står utanför den organisation som söker bidraget.":
    "are outside the organisation applying for the grant.",
  "Referenterna ska kunna bedöma projektets relevans och genomförbarhet, men får inte själva tillhöra den sökande organisationen.":
    "The references must be able to assess the project's relevance and feasibility, but must not themselves belong to the applying organisation.",
  "2. Projektbudget": "2. Project budget",
  "Bifoga en tydlig budget för projektet.":
    "Attach a clear budget for the project.",
  "Budgeten ska visa projektets beräknade kostnader och hur det sökta bidraget är tänkt att användas.":
    "The budget must show the project's estimated costs and how the requested grant is intended to be used.",
  "3. Årsredovisning": "3. Annual report",
  "Bifoga organisationens senaste årsredovisning.":
    "Attach the organisation's most recent annual report.",
  "Årsredovisningen ska ge en tydlig och transparent bild av organisationens ekonomi och verksamhet. Resultat- och balansräkning ska vara tillräckligt specificerade.":
    "The annual report must give a clear and transparent picture of the organisation's finances and activities. The income statement and balance sheet must be sufficiently itemised.",
  "En redovisning där exempelvis samtliga kostnader endast anges som en totalsumma ger inte tillräckligt underlag för bedömningen.":
    "A report where, for example, all costs are stated only as a total sum does not provide a sufficient basis for the assessment.",
  "Om den ekonomiska redovisningen är alltför knapphändig kan ansökan bedömas som ofullständig och därför inte tas upp till behandling.":
    "If the financial reporting is too sparse, the application may be considered incomplete and therefore not be processed.",
  "4. Verksamhetsberättelse": "4. Activity report",
  "Bifoga organisationens senaste verksamhetsberättelse, så att KC-Fonden kan få en tydlig bild av organisationens verksamhet och tidigare arbete.":
    "Attach the organisation's most recent activity report, so that KC-Fonden can get a clear picture of the organisation's activities and previous work.",
  "5. Stadgar": "5. Statutes",
  "Bifoga organisationens stadgar.": "Attach the organisation's statutes.",
  "Eftersom handläggning och beslut tar viss tid gäller följande starttidpunkter:":
    "As processing and decisions take some time, the following start dates apply:",
  "Ett projekt som ansökan gäller får tidigast påbörjas i juli samma år.":
    "A project covered by the application may start in July of the same year at the earliest.",
  "Ett projekt som ansökan gäller får tidigast påbörjas i januari året därpå.":
    "A project covered by the application may start in January of the following year at the earliest.",
  "KC-Fonden beviljar således inte bidrag till projekt som redan har genomförts.":
    "KC-Fonden therefore does not award grants to projects that have already been carried out.",
  "För att kunna komma i fråga för bidrag ska projektet:":
    "To be considered for a grant, the project must:",
  "rikta sig till barn eller ungdomar med särskilda behov,":
    "target children or young people with special needs,",
  "avse omvårdnad, stöd eller annan relevant insats,":
    "concern care, support or another relevant initiative,",
  "vara ett nytt eller ännu inte genomfört projekt, där pilotprojekt särskilt prioriteras,":
    "be a new or not yet implemented project, with pilot projects particularly prioritised,",
  "ha två externa referenter,": "have two external references,",
  "ha en tydlig projektbudget, och": "have a clear project budget, and",
  "kompletteras med årsredovisning, verksamhetsberättelse och stadgar.":
    "be accompanied by the annual report, activity report and statutes.",
  "KC-Fonden prioriterar nya och prövande projekt framför finansiering av redan etablerad eller löpande verksamhet.":
    "KC-Fonden prioritises new and exploratory projects over funding of already established or ongoing activities.",
  "Om du varken har personnummer eller samordningsnummer anger du ditt födelsedatum följt av fyra nollor (ÅÅÅÅMMDD-0000).":
    "If you have neither a Swedish personal identity number nor a coordination number, enter your date of birth followed by four zeros (YYYYMMDD-0000).",
  "Stipendiet är avsett för studier och utbildning och kan inte användas för instrumentköp.":
    "The scholarship is intended for studies and education and cannot be used for instrument purchases.",
  "Stöd till barn och ungdomar med särskilda behov":
    "Support for children and young people with special needs",
} as const;

export default en;
